import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathEquals: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMathEquals"><Path fillRule="evenodd" clipRule="evenodd" d="M4 9.5C4 9.22386 4.22386 9 4.5 9H19.5C19.7761 9 20 9.22386 20 9.5C20 9.77614 19.7761 10 19.5 10H4.5C4.22386 10 4 9.77614 4 9.5ZM4 14.5C4 14.2239 4.22386 14 4.5 14H19.5C19.7761 14 20 14.2239 20 14.5C20 14.7761 19.7761 15 19.5 15H4.5C4.22386 15 4 14.7761 4 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathEquals;
